/* global log */
/* global gettext */
/* global PrintUtils */
/* global Utils */
/* global SculpteoOperationWizardUI */

// Patch popup message so that it appears in notification zone
Utils.popupMessage = function (s, new_class) {
  var $nz = $(".notification-zone");

  $(".message", $nz).html(s);

  if (new_class) {
    $(".message", $nz).addClass(new_class);
  }

  $(".message", $nz).slideDown();
  setTimeout(function () {
    $(".message", $nz).fadeOut("slow", function () {
      if (new_class) {
        $(".message", $nz).removeClass(new_class);
      }
    });
  }, 6000);
};

// Private helpers used by multiple components

function PrintUI(design, mode, viewerUI, viewerOverlayWidget, seriesDisabled) {
  var _this = this;

  this.design = design;
  this.mode = mode;
  this.viewerUI = viewerUI;
  this.viewerOverlayWidget = viewerOverlayWidget;
  this.seriesDisabled = seriesDisabled;
  this.dfd_update_materials = true;
  this.materials_status = 0;

  design.order.material_slug_to_pk = {};

  for (var k in design.order.materials) {
    design.order.material_slug_to_pk[design.order.materials[k].slug] = k;
  }

  var update_design_material = function (design) {
    viewerUI.update_sliced_render();
    var m = design.material.encoded(design.size);

    if (design.model_uuid == _this.design.model_uuid) {
      viewerUI.viewer_update(m);
    } else {
      design.node.setMaterial(
        m.material,
        m.envmap,
        m.smooth_normals,
        m.bumpnoise,
        m.gaussian_amplitude
      );
    }
  };

  $.Topic("material-selected").subscribe(function (design, material, finish) {
    material.delay = undefined;
    material.receipt_date = undefined;
    $.Topic("request_update_materials").publish(true, false, false, true);
  });

  $.Topic("update-quantity").subscribe(function (design, quantity) {
    design.order.quantity = quantity;
    $.Topic("invalidate_delay").publish();

    if (design.series.enabled) {
      $.Topic("invalidate_price").publish();
    } else {
      if (_this.check_series_errors(design).length) {
        $.Topic("update_price").publish();
      } else {
        $.Topic("invalidate_price").publish();
      }
    }

    $.Topic("request_update_materials").publish(true);

    if (!design.series.enabled) {
      $.Topic("update_price").publish();
    }

    $.Topic("quantity-changed").publish(design, quantity);
  });

  $.Topic("update-size").subscribe(function (design, size_id) {
    if (design.model_uuid) {
      design
        .update_print_op(undefined, undefined, size_id, undefined, undefined)
        .then(function () {
          $.Topic("size-changed").publish(design, size_id);
          $.Topic("scale-changed").publish(design, design.sizes[size_id].scale);
          $.Topic("unit-changed").publish(design, design.sizes[size_id].unit);
        });

      design.size.size_id = size_id;
      design.size.userScale = design.sizes[size_id].scale;
      design.size.unit = design.sizes[size_id].unit;
    } else {
      design.size.size_id = size_id;
      design.size.userScale = design.sizes[size_id].scale;
      design.size.unit = design.sizes[size_id].unit;
      $.Topic("size-changed").publish(design, size_id);
      $.Topic("scale-changed").publish(design, design.sizes[size_id].scale);
      $.Topic("unit-changed").publish(design, design.sizes[size_id].unit);
    }
  });

  $.Topic("update-scale").subscribe(function (design, scale) {
    if (design.model_uuid) {
      design
        .update_print_op(scale, undefined, undefined, undefined, undefined)
        .then(
          function () {
            $.Topic("scale-changed").publish(design, scale);
          },
          function () {
            $.Topic("update_price").publish();
            $.Topic("update_delay").publish();
          }
        );

      design.size.userScale = scale;
    } else {
      design.size.userScale = scale;
      $.Topic("scale-changed").publish(design, scale);
    }
  });

  $.Topic("scale-changed").subscribe(function (design, scale) {
    if (!PrintUtils.design_get_hollowing(design)) {
      $.Topic("request_update_materials").publish(true);
    }
  });

  $.Topic("update-unit").subscribe(function (design, unit) {
    if (design.model_uuid) {
      design
        .update_print_op(undefined, unit, undefined, undefined, undefined)
        .then(
          function () {
            $.Topic("unit-changed").publish(design, unit);
          },
          function () {
            $.Topic("update_price").publish();
            $.Topic("update_delay").publish();
          }
        );

      design.size.unit = unit;
    } else {
      design.size.unit = unit;
      $.Topic("unit-changed").publish(design, unit);
    }
  });

  $.Topic("unit-changed").subscribe(function (design, unit) {
    if (!PrintUtils.design_get_hollowing(design)) {
      $.Topic("request_update_materials").publish(true);
    }
  });

  $.Topic("currency-changed").subscribe(function (currency) {
    _this.design.order.currency = currency;
    $.Topic("request_update_materials").publish(true);
  });

  $.Topic("request_update_materials").subscribe(function (
    force_update,
    all_materials,
    update_all_prices,
    updating_delays
  ) {
    if (_this.dfd_update_materials === true) {
      _this.dfd_update_materials = $.Deferred();
    }

    var dfd_update = _this.dfd_update_materials;

    var series = _this.design.series.enabled;

    _this.check_and_set_series();

    // Update materials only when forced, series are enabled or series state changes
    if (
      force_update ||
      _this.design.series.enabled ||
      series != _this.design.series.enabled
    ) {
      var dfd = true;

      // If series went from enabled to disabled, set pack to zero
      if (updating_delays) {
        $.Topic("set-viewer-toolbar-message").publish(
          gettext("Updating delays")
        );
      } else if (_this.design.series.enabled) {
        $.Topic("set-viewer-toolbar-message").publish(
          gettext("Updating batch price")
        );
      } else {
        $.Topic("set-viewer-toolbar-message").publish(
          gettext("Updating price")
        );
      }

      Utils.viewerProgressBar();

      if (
        _this.design.series.enabled ||
        series != _this.design.series.enabled
      ) {
        var quantity = 0;

        if (_this.design.series.enabled) {
          quantity = _this.design.order.quantity;
        }

        dfd = $.Deferred();
        _this.design
          .update_print_op(undefined, undefined, undefined, quantity, undefined)
          .then(function (data) {
            // This function is used to resolve the deferred only when the model is completely
            // refreshed. If we don't wait for this to happen, asynchronous calls can mess up the code
            // that require fields computed during the refresh. So we bind that function on "progress"
            // and check whenever it hits 100% to be sure we can safely resolve.
            var after_refresh = function (progress) {
              if (progress == 100) {
                _this.viewerUI.viewer.unbind("progress", after_refresh);
                dfd.resolve();
              }
            };

            _this.viewerUI.viewer.bind("progress", after_refresh);
            _this.viewerUI.topics["operation-updated"](data);
          })
          .fail(function () {
            dfd.resolve();
          });
      }

      $.when(
        dfd,
        _this.design.dfd_update_scale,
        _this.design.dfd_update_material
      ).then(function () {
        // Update series material on update_material finished
        var func = function () {
          $.Topic("materials-update-result").unsubscribe(func);
          $.Topic("materials-update-error").unsubscribe(funcerr);

          if (_this.design.series.enabled) {
            if (_this.design.partitioning) {
              for (var k = 0; k < _this.design.partitioning.parts.length; k++) {
                console.log(_this.design.partitioning.parts[k].material);
              }
            }

            var materials = [_this.design.material];

            if (_this.design.partitioning) {
              for (var k = 0; k < _this.design.partitioning.parts.length; k++) {
                materials[k] = _this.design.partitioning.parts[k].material;
              }
            }

            _this.viewerUI.update_series.apply(_this.viewerUI, materials);
          }

          $.Topic("set-viewer-toolbar-message").publish("");
          Utils.viewerProgressBar(0);
          dfd_update.resolve();
          _this.dfd_update_materials = true;
        };

        var funcerr = function () {
          _this.update_materials(all_materials, update_all_prices);
        };

        $.Topic("materials-update-result").subscribe(func);
        $.Topic("materials-update-error").subscribe(funcerr);
        _this.update_materials(all_materials, update_all_prices);
      });
    }
  });

  $.Topic("series-orientation-changed").subscribe(function (orientation) {
    $.Topic("request_update_materials").publish(true);
  });

  $.Topic("review-mode").subscribe(function (enabled) {
    _this.update_review(enabled);
  });

  $.Topic("request-model-refresh").subscribe(function (data) {
    _this.viewerUI.topics["operation-updated"](data);
  });

  $.Topic("material-selected").subscribe(function (
    design,
    material,
    finish,
    painting
  ) {
    if (design.partitioning) {
      return;
    }

    _this.viewerUI.show_design();
    var m = material.encoded(design.size, finish, painting);

    if (design.model_uuid == _this.design.model_uuid) {
      _this.viewerUI.viewer_update(m);
    } else {
      design.node.setMaterial(
        m.material,
        m.envmap,
        m.smooth_normals,
        m.bumpnoise,
        m.gaussian_amplitude
      );
      $(".material_label_" + design.model_uuid).html(
        gettext(design.material.name)
      );
    }

    var cmp = PrintUtils.compareMaterials(
      design,
      material,
      finish,
      painting,
      design.printui.lastMaterial,
      design.printui.lastFinish,
      design.printui.lastPainting
    );

    design.printui.lastMaterial = material;
    design.printui.lastFinish = finish;
    design.printui.lastPainting = painting;

    // Update materials only if in series and material is different, or series are to be enabled
    if (
      (!cmp[0] && design.series.enabled) ||
      (!design.series.enabled && !_this.check_series_errors(design).length)
    ) {
      $.Topic("request_update_materials").publish();
    }
  });

  $.Topic("material-enter").subscribe(function (material, finish) {
    var m = material.encoded(_this.design.size);

    _this.viewerUI.viewer_update(m);
  });

  $.Topic("material-leave").subscribe(function () {
    var m = _this.design.material.encoded(_this.design.size);

    _this.viewerUI.viewer_update(m);
  });

  $.Topic("materials-update-result").subscribe(function () {
    if (_this.design.series.enabled) {
      $(".series-button").removeClass("disabled");
    } else {
      $(".series-button").addClass("disabled");
    }
  });

  $.Topic("hollowing-status-update").subscribe(function (enable, msg) {
    if (!enable && msg && msg != "") {
      $.Topic("set_mesh_warnings").publish([msg]);
      msg = gettext(msg);
    } else {
      msg = "";

      if (enable) {
        $.Topic("set_mesh_warnings").publish([]);
      }
    }

    $.Topic("hollowing-toggle-enable").publish(enable, msg);
  });

  $.Topic("hollowing-toggle-enable").subscribe(function (enable, msg) {
    if (enable) {
      $("#hollowingToggle, #hollowingToggle2").unblock();
      $("#hollowingToggle, #hollowingToggle2").removeClass("disabled");
    } else {
      $("#hollowingToggle, #hollowingToggle2").block();
      $("#hollowingToggle .blockUI, #hollowingToggle2 .blockUI").css(
        "cursor",
        "default"
      );
      $(
        "#hollowingToggle .blockUI:nth-last-child(2), #hollowingToggle2 .blockUI:nth-last-child(2)"
      ).tooltip({
        bodyHandler: function () {
          return msg;
        },

        top: -80,
        left: -120,
        showURL: false,
      });
      $("#hollowingToggle, #hollowingToggle2").addClass("disabled");
    }
  });

  $.Topic("unit-changed").subscribe(function (design, size) {
    update_design_material(design);
  });

  $.Topic("scale-changed").subscribe(function (design, scale) {
    update_design_material(design);
    viewerUI.update_display_grid();
  });

  $.Topic("size-changed").subscribe(function (design, size_id) {
    update_design_material(design);
  });

  $(".tab-item").on("click", function () {
    var tabid = $(this).data("tabid");

    _this.select_tab(tabid);
    $.Topic("tab-selected").publish(tabid);
  });

  $("#StaffHollowing #ModifyButton").bind("click.printui", function () {
    _this.select_tab("optimize");
  });

  $("#production-center-widget [data-close]").click(function (e) {
    e.preventDefault();
    _this.hideProductionCenterPopin();
  });

  $("[data-production-center-button]").click(function (e) {
    e.preventDefault();
    _this.showProductionCenterPopin();
  });

  $("#production-center-widget [name=production_center]").change(function (e) {
    $("#production-center-widget label").removeClass("checked");
    $(e.currentTarget).parent().addClass("checked");
    //$('#production-center-widget form').submit();
  });

  $("#production-center-widget form").submit(function (e) {
    e.preventDefault();

    var production_center = $(
      "#production-center-widget [name=production_center]:checked"
    ).val();

    _this.saveProductionCenter(production_center, function () {
      _this.hideProductionCenterPopin();
      _this.updateProductionCenterButtonText(production_center);
      _this.design.order.production_center = production_center;
      $.Topic("request_update_materials").publish(true);

      // Setting a material from the selected production center
      if (
        production_center > 0 &&
        production_center !== _this.design.material.shipping_site
      ) {
        var material =
          _this.design.order.material_group_manager.get_material_of_group_by_shipping_site(
            _this.design.material.slug,
            production_center
          );
        if (material && material.slug !== _this.design.material.slug) {
          $.when(
            _this.design.material == material || _this.design.model_uuid
              ? _this.design.update_print_material(material, null, null)
              : _this.design.set_material(material)
          ).then(function (data) {
            _this.design.set_material(material);
            _this.design.order.finish = null;
            _this.design.order.painting = null;
            $.Topic("material-selected").publish(_this.design, material);
          });
        }
      }
    });
  });

  if (parseInt(this.design.manufacturing_type, 10) === 2) {
    var production_center = $(
      "#production-center-widget [name=production_center]:checked"
    ).val();
    this.design.order.production_center = production_center;
    this.updateProductionCenterButtonText(production_center);
  }
}

PrintUI.prototype = {
  ready: function () {
    var _this = this;
    var parts = this.design.partitioning
      ? this.design.partitioning.parts
      : [this.design];

    for (var i = 0; i < parts.length; ++i) {
      var part = parts[i];

      part.printui = {
        lastMaterial: part.material,
        lastFinish: part.order.finish,
        lastPainting: part.order.painting,
      };
    }

    var viewer = $("#viewer3d").Sculpteo3DViewer();

    $(window).on("blur", function (e) {
      viewer.setAutorotate(false);
    });

    $.Topic("arrange_parts").subscribe(function () {
      _this.arrange_parts();
    });

    $.Topic("design_cloned").subscribe(function (design, clone) {
      clone.printui = {
        lastMaterial: clone.order.materials[design.printui.lastMaterial.id],
        lastFinish: design.printui.lastFinish,
        lastPainting: design.printui.lastPainting,
      };
    });
  },

  select_tab: function (tabid) {
    if ($(".leftDirection").css("background-position") === "0px -20px") {
      $(".leftDirection").trigger("click");
    }

    if (tabid === "material") {
      $("#material-tab").css(
        "height",
        parseInt($(".material-details-column").css("height"), 10) + 20
      );
    } else {
      this.viewerUI.show_design();
    }

    $("#print-menu>li").removeClass("selected");
    $("#" + tabid + "-button")
      .parent()
      .addClass("selected");
    $(".print-menu-content>div").hide();
    $("#" + tabid + "-tab").show();
    $(".cutaway-options").addClass("hidden");
    $("#cutawayToggle .switch, #cutawayToggle2 .switch").addClass("off");
    $("#cutawayToggle .switch, #cutawayToggle2 .switch").removeClass("on");
    $("#annotationToggle .switch").addClass("off");
    $("#annotationToggle .switch").removeClass("on");
    $.Topic("printui-tab-changed").publish(tabid);
  },

  update_materials: function (all_materials, update_all_prices) {
    all_materials = all_materials || false;
    var _this = this;
    var parts = [this.design];

    if (this.design.partitioning) {
      parts = this.design.partitioning.parts;
    }

    this.materials_status = 1;
    $.Topic("materials-update-start").publish(all_materials);

    if (parts.length == 0) {
      $.Topic("materials-update-result").publish([]);

      return;
    }

    var data = {};
    var dfds = [];

    for (var k = 0; k < parts.length; k++) {
      var part = parts[k];

      if (part.model_uuid) {
        data["editinfo_" + k] = part.model_uuid;
      } else {
        data["uuid_" + k] = part.design_uuid;
      }

      if (part.size.size_id) {
        // Common constraint (not sure how to handle that actually..)
        data["size_" + k] = part.size.size_id;
      }

      data["quantity_" + k] = part.order.quantity;
      data["scale_" + k] = part.size.userScale;
      data["unit_" + k] = part.size.unit; // Common unit
      data["material_" + k] = all_materials
        ? "-" + part.material.slug
        : part.material.slug;
      data["currency_" + k] = part.order.currency;
      if (all_materials) {
        data["no_delays"] = "1";
      }
    }

    if (window.theme) {
      data["theme"] = window.theme;
    }

    if (!all_materials && update_all_prices !== false) {
      var called = false;
      var call_update_all_materials = function () {
        if (called) {
          $.Topic("materials-update-result").unsubscribe(
            call_update_all_materials
          );
          $.Topic("set-viewer-toolbar-message").publish("");
        } else {
          called = true;
          $.Topic("set-viewer-toolbar-message").publish(
            gettext("Updating materials")
          );
          Utils.viewerProgressBar();
          _this.update_materials(true);
        }
      };

      $.Topic("materials-update-result").subscribe(call_update_all_materials);
    }

    if (_this.design.order.production_center) {
      data["shipping_site"] = _this.design.order.production_center;
    }

    dfds.push(
      _this.design.order.ajax_materials.add_post(URLS.x_get_price, data)
    );

    $.when
      .apply(null, dfds)
      .then(function () {
        Utils.viewerProgressBar(0);
        _this.materials_status = 0;
        $.Topic("materials-update-result").publish(arguments); // Multipart materials info
      })
      .fail(function (jqXHR) {
        Utils.viewerProgressBar(0);
        _this.materials_status = 2;
        $.Topic("materials-update-error").publish(jqXHR);
      });
  },

  update_review: function (enabled) {
    if (enabled) {
      if ($(".leftDirection").css("background-position") === "0px -20px") {
        $(".leftDirection").trigger("click");
      }

      this.viewerUI.toggle_solidity_check(true);
      this.viewerUI.toggle_display_grid(true);
      $(".cutaway-options").addClass("hidden");
      $("#cutawayToggle .switch, #cutawayToggle2 .switch").addClass("off");
      $("#cutawayToggle .switch, #cutawayToggle2 .switch").removeClass("on");
    } else if (!$("#review-button").parent().hasClass("selected")) {
      this.viewerUI.toggle_solidity_check(false);
      this.viewerUI.toggle_display_grid(false);
    }
  },

  check_and_set_series: function () {
    if (this.seriesDisabled) {
      return;
    }

    var errors = this.check_series_errors(this.design);
    var enabled = this.design.series.enabled;

    if (errors.length) {
      this.viewerUI.toggle_series(false, true);

      if (
        this.viewerOverlayWidget.screen &&
        this.viewerOverlayWidget.screen.startsWith("series") &&
        this.viewerOverlayWidget.screen != "series-orient"
      ) {
        this.viewerOverlayWidget.select_screen();
      }

      $(".series-height").slideUp();
      $(".series-button").addClass("disabled").data("errors", errors);
    } else {
      this.viewerUI.toggle_series(true, true);
    }

    if (errors.length && enabled) {
      Utils.popupMessage(
        "<div class='hint'>" +
          gettext("Your item now qualifies for Batch Control") +
          "</div>"
      );
    } else if (!errors.length && !enabled) {
      var hint = gettext("Your item now qualifies for Batch Control");

      // Series options will disable economy_mode and fast_mode
      if ($(".price-widget [name=production_mode]:checked").val() !== "") {
        hint +=
          "<br/>" +
          gettext("Batch Control is only available using Standard Production.");
        $(".price-widget [name=production_mode]:first").click();
      }

      Utils.popupMessage("<div class='hint'>" + hint + "</div>");
    }
  },

  check_series_errors: function (design) {
    var errors = [];

    if (design.partitioning) {
      errors.push(
        gettext("Batch Control is only available for single part designs")
      );

      return errors;
    }

    if (design.order.quantity < 20) {
      errors.push(
        gettext(
          "Batch Control is only available for orders of 20 or more prints"
        )
      );
    }

    // Check object always fits in Arreau printer in any orientation the user could force
    if (design.material.printer) {
      var size = design.size.get();
      var scale = design.size.unitFactor();
      var bbox = [size.x * scale, size.y * scale, size.z * scale];
      var print_box = [
        design.material.printer.max_x,
        design.material.printer.max_y,
        design.material.printer.max_z,
      ];

      bbox.sort(function (a, b) {
        return a - b;
      });

      print_box.sort(function (a, b) {
        return a - b;
      });

      if (
        bbox[0] > print_box[0] ||
        bbox[1] > print_box[1] ||
        bbox[2] > print_box[2]
      ) {
        errors.push(
          gettext("Your design's scale is too large for Batch Control")
        );
      }
    }

    return errors;
  },

  arrange_parts: function (use_on_load) {
    var _this = this;
    var parts = this.design.partitioning ? this.design.partitioning.parts : [];
    var dfds = [];

    if (!parts || parts.length == 0) {
      return;
    }

    if (use_on_load) {
      for (var k = 0; k < parts.length; k++) {
        var part = parts[k];

        part.node._print_load_dfd = $.Deferred();
        part.node._print_load_dfd_listener = function (progress) {
          if (progress == "100") {
            this.removeEventListener("load", this._print_load_dfd_listener);
            this._print_load_dfd.resolve();
            delete this._print_load_dfd;
          }
        };

        part.node.addEventListener("load", part.node._print_load_dfd_listener);
        dfds.push(part.node._print_load_dfd);
      }
    } else {
      dfds = [true];
    }

    $.when.apply(null, dfds).then(function () {
      var viewer = _this.viewerUI.viewer;
      var old_local = viewer.getLocal();

      if (!old_local) {
        viewer.setLocal(true);
      }

      viewer.clearStatusMessage();
      var rootNode = viewer.getScene();

      rootNode.destructChildren();

      var height = 0;
      var width = 0;
      var depth = 0;
      var k, i;

      for (k = 0; k < parts.length; k++) {
        var part = parts[k];
        var scale = part.size.scaleFactor();

        height += part.size.z * scale;
        var w =
          scale *
          part.size.x *
          (part.order.quantity + (part.order.quantity - 1) * 0.2);

        if (w > width) {
          width = w;
        }

        if (depth < scale * part.size.y) {
          depth = scale * part.size.y;
        }
      }

      var spacing = (height * 0.2) / parts.length;

      spacing = Math.max(spacing, 2.0);

      height += spacing * (parts.length - 1);

      var part_height = 0;

      for (k = 0; k < parts.length; k++) {
        part = parts[k];

        if (!part.nodes) {
          part.nodes = [];
        }

        var scale = part.size
          ? part.size.userScale
            ? part.size.scaleFactor()
            : 1.0
          : 1.0;

        part_height += scale * (part.size.z / 2);

        var tx = -scale * part.center.x;
        var ty = -scale * part.center.y;
        var tz = height / 2 - part_height - part.center.z * scale;
        var transform = new Sculpteo3DViewerTransform3D();
        var s = Sculpteo3DViewerTransform3D.scale(scale, scale, scale);

        var m = Sculpteo3DViewerTransform3D.translation(tx, ty, tz);
        var node_tr = transform.x(m);

        node_tr = node_tr.x(s);
        rootNode.appendChild(part.node);
        part.node.setTransform(node_tr);
        part.transform = new Sculpteo3DViewerCommonTransform3D(
          node_tr.toString()
        );

        if (part.nodes.length >= part.order.quantity) {
          for (i = 1; i < part.order.quantity; ++i) {
            var ptx = tx + scale * part.size.x * i * 1.2;

            m = Sculpteo3DViewerTransform3D.translation(ptx, ty, tz);
            node_tr = transform.x(m);
            node_tr = node_tr.x(s);
            part.nodes[i - 1].setTransform(node_tr);
            part.node.getParent().appendChild(part.nodes[i - 1]);
          }

          for (i = part.order.quantity - 1; i < part.nodes.length; ++i) {
            part.nodes[i].detach();
          }
        } else {
          for (i = 1; i < part.nodes.length + 1; ++i) {
            var ptx = tx + scale * part.size.x * i * 1.2;

            m = Sculpteo3DViewerTransform3D.translation(ptx, ty, tz);
            node_tr = transform.x(m);
            node_tr = node_tr.x(s);
            part.nodes[i - 1].setTransform(node_tr);
            part.node.getParent().appendChild(part.nodes[i - 1]);
          }

          for (i = part.nodes.length + 1; i < part.order.quantity; ++i) {
            var ptx = tx + scale * part.size.x * i * 1.2;

            m = Sculpteo3DViewerTransform3D.translation(ptx, ty, tz);
            node_tr = transform.x(m);
            node_tr = node_tr.x(s);
            var node = viewer.createNode(
              part.node.id,
              node_tr,
              part.material.encoded().material
            );

            part.node.getParent().appendChild(node);
            part.nodes.push(node);
          }
        }

        part_height += (scale * part.size.z) / 2 + spacing;
      }

      viewer.updateSceneTransform();

      if (!old_local) {
        viewer.setLocal(false);
      }
    });
  },

  animate_parts: function (skip_load_op) {
    var design = this.design;

    // Look for the repack operation
    var op_repack;

    for (var i in design.operations) {
      if (design.operations[i].klass == "RepackGroupsDesignOperation") {
        op_repack = design.operations[i];
        break;
      }
    }

    if (!op_repack) {
      return;
    }

    var parts = design.partitioning ? design.partitioning.parts : [];

    if (!parts) {
      return;
    }

    var scale = design.size.x;

    if (design.size.y > scale) {
      scale = design.size.y;
    }

    if (design.size.z > scale) {
      scale = design.size.z;
    }

    scale *= 0.5;
    var transform = Sculpteo3DViewerTransform3D.identity;
    var tx = design.center.x;
    var ty = design.center.y;
    var tz = design.center.z;
    var s = Sculpteo3DViewerTransform3D.scale(scale, scale, scale);
    var m = Sculpteo3DViewerTransform3D.translation(tx, ty, tz);

    transform = transform.x(m);
    transform = transform.x(s);
    transform = transform.inverse();

    var viewer = this.viewerUI.viewer;

    viewer.setSceneTransform(transform.toString());

    // Wait for all parts to load and start the animation
    var dfds = [];

    if (!skip_load_op) {
      for (var k = 0; k < parts.length; k++) {
        var part = parts[k];

        part.node._print_load_dfd = $.Deferred();
        part.node._print_load_dfd_listener = function () {
          this.removeEventListener("load", this._print_load_dfd_listener);
          this._print_load_dfd.resolve();
          delete this._print_load_dfd;
        };

        part.node.addEventListener("load", part.node._print_load_dfd_listener);
        dfds.push(part.node._print_load_dfd);
      }
    } else {
      dfds = [true];
    }

    $.when.apply(null, dfds).then(function () {
      viewer.clearStatusMessage();

      if (!op_repack.data._packing) {
        return;
      }

      var packing = op_repack.data._packing.split(",");

      for (var k = 0; k < packing.length; k += 4) {
        var idx = parseInt(packing[k], 10);
        var x = parseFloat(packing[k + 1]);
        var y = parseFloat(packing[k + 2]);
        var z = parseFloat(packing[k + 3]);
        var transform = new Sculpteo3DViewerTransform3D();
        var scale = parts[idx].scale ? parts[idx].scale : 1.0;

        transform = transform.scale(scale, scale, scale);
        transform = transform.translate(x, y, z);
        parts[idx].transform = new Sculpteo3DViewerCommonTransform3D(
          transform.toString()
        );

        parts[idx].node.animate(
          {
            transform: transform,
          },
          2000
        );
      }
    });
  },

  showProductionCenterPopin: function () {
    $("#production-center-widget").fadeIn();
  },

  hideProductionCenterPopin: function () {
    $("#production-center-widget").fadeOut();
  },

  saveProductionCenter: function (production_center, callback) {
    return $.post(
      $("#production-center-widget form").attr("action"),
      { production_center: production_center },
      callback
    );
  },

  updateProductionCenterButtonText: function (production_center) {
    var text = gettext("Full Catalog");
    var css = "";

    if (parseInt(production_center, 10) === 1) {
      text = gettext("USA preferred");
      css = "usa";
    } else if (parseInt(production_center, 10) === 2) {
      text = gettext("EU preferred");
      css = "eur";
    }

    $("[data-production-center-button]")
      .html(text)
      .removeClass("usa eur")
      .addClass(css);
  },
};
